import type { StackProps } from '@chakra-ui/react';
import { Box, HStack } from '@chakra-ui/react';

export const ProgressBar = ({
  total,
  done,
  ...props
}: {
  total: number;
  done: number;
} & StackProps) => {
  return (
    <HStack justifyContent="space-between" {...props}>
      {Array.from({ length: total }).map((_, index) => {
        return (
          <Box
            flex={1}
            key={index}
            h="4px"
            bgColor={index < done ? '#159DFF' : '#FFFFFF33'}
          />
        );
      })}
    </HStack>
  );
};
